<template>
  <div id="searchBar" :class="['search-bar', {'has-background' : data.hasBg}]">
    <div class="search-box" @click="searchClick">
      <van-icon class="iconfont" class-prefix="icon" name="sousuo"></van-icon>{{data.title}}
    </div>
    <div class="assistant" v-if="data.qabotSwitch">
      <van-icon class="iconfont" class-prefix="icon" :name="data.icon" @click="iconClick"></van-icon>
    </div>
  </div>
</template>

<script>
export default {
  name: "SearchBar",
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          title: "搜索您要办理的事项", // 标题
          icon:'jiqiren', // icon的名称
          hasBg: false, //是否有背景色
          iconEmitCallback: null, //图标点击事件回调函数名称
          searchEmitCallback: null,
          qabotSwitch: false
        }
      }
    }
  },
  methods: {
    searchClick() {
      if (!(this.data.searchEmitCallback == "" || this.data.searchEmitCallback == null || this.data.searchEmitCallback == undefined)) {
        this.$emit(this.data.searchEmitCallback);
      }
    },
    iconClick() {
      if (!(this.data.iconEmitCallback == "" || this.data.iconEmitCallback == null || this.data.iconEmitCallback == undefined)) {
        this.$emit(this.data.iconEmitCallback);
      }
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/css/theme/theme";
.search-bar {
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  z-index:10001;
  width: 100%;
  height: 44px;
  padding: 8px 15px;
  box-sizing: border-box;
  display: -webkit-flex;/* Safari */
  background: rgba(0, 0, 0,.1);
  backdrop-filter: blur(6px);
  transition: all .5s ease;

  &.has-background {
    background: var(--main-color);
  }

  .search-box {
    height: 28px;
    padding: 0 17px;
    box-sizing: border-box;
    border: 1px solid #fff;
    border-radius: 14px;
    color: #fff;
    line-height: 28px;
    display: inline-flex;
    flex: 1;
    @extend .font13;

    i {
      margin-right: 5px;
    }
  }

  .assistant {
    width: 19px;
    height: 28px;
    margin-left: 12px;
    color: #fff;
    .iconfont {
      display: block;
      font-size: 20px;
      line-height: 28px;
    }
  }
}
</style>
